<template>
  <v-row class="py-1 px-5 grey lighten-4 fill-height">
    <v-col cols="12">
      <v-row>
        <v-col cols="12" SearchC>
          <Search
            :loading="loading"
            :resourceSettings="resourceSettings"
            @searchResource="searchResource"
            @create="dialog = true"
          />
        </v-col>
        <v-col cols="12">
          <v-card class="px-3" :loading="loading">
            <v-card-text>
              <v-row class="pa-0 align-center">
                <v-col
                  cols="12"
                  :md="`${resourceSettings.create ? '6' : '9'}`"
                  :class="`${$vuetify.breakpoint.md ? 'pa-0' : 'py-1'}`"
                >
                  <span
                    class="font-weight-bold "
                    style="font-size: 15px;"
                    v-if="!loading"
                    >{{ resource.meta.total }}
                    {{ i18n.available_jobs_listings }}</span
                  >
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" FILTERS>
          <v-card class="px-3" :loading="loading">
            <v-card-text>
              <v-row class="pa-0">
                <v-col
                  cols="12"
                  md="4"
                  :class="`${arabic ? 'arFont' : 'enFont'} pa-1`"
                >
                  <v-autocomplete
                    :items="resource.states"
                    v-model="state_id"
                    :label="i18n.states"
                    autocomplete="disabled"
                    outlined
                    hide-details
                    multiple
                    dense
                    clearable
                    item-value="id"
                    item-text="de"
                    :class="`${arabic ? 'arFont' : 'enFont'}`"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col
                  cols="12"
                  md="4"
                  :class="`${arabic ? 'arFont' : 'enFont'} pa-1`"
                >
                  <v-autocomplete
                    :items="resource.cities"
                    v-model="city_id"
                    :label="i18n.city"
                    autocomplete="disabled"
                    outlined
                    hide-details
                    multiple
                    clearable
                    dense
                    item-value="id"
                    item-text="de"
                    :class="`${arabic ? 'arFont' : 'enFont'}`"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col
                  cols="12"
                  md="4"
                  :class="`${arabic ? 'arFont' : 'enFont'} pa-1`"
                >
                  <v-autocomplete
                    :items="resource.occupations"
                    v-model="occupation_id"
                    :label="i18n.occupation"
                    autocomplete="disabled"
                    outlined
                    hide-details
                    multiple
                    clearable
                    dense
                    item-value="id"
                    item-text="de"
                    :class="`${arabic ? 'arFont' : 'enFont'}`"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col
                  cols="12"
                  md="4"
                  :class="`${arabic ? 'arFont' : 'enFont'} pa-1`"
                >
                  <v-autocomplete
                    :items="contract_type"
                    v-model="contract_category_type"
                    :label="i18n.contract_category_type"
                    autocomplete="disabled"
                    outlined
                    hide-details
                    clearable
                    dense
                    item-value="value"
                    item-text="text"
                    :class="`${arabic ? 'arFont' : 'enFont'}`"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col
                  cols="12"
                  md="4"
                  :class="`${arabic ? 'arFont' : 'enFont'} pa-1`"
                >
                  <v-menu
                    v-model="menu1"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="fromDate"
                        label="From Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        outlined
                        hide-details
                        dense
                        clearable
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="fromDate"
                      @input="menu1 = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col
                  cols="12"
                  md="4"
                  :class="`${arabic ? 'arFont' : 'enFont'} pa-1`"
                >
                  <v-menu
                    v-model="menu2"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="toDate"
                        label="To Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        hide-details
                        outlined
                        dense
                        clearable
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="toDate"
                      @input="menu2 = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>

                <v-col
                  cols="12"
                  md="4"
                  :class="`${arabic ? 'arFont' : 'enFont'} pa-1`"
                >
                  <v-text-field
                    v-model="number_of_vacancies"
                    :label="i18n.vacancies"
                    autocomplete="disabled"
                    type="number"
                    outlined
                    hide-details
                    dense
                    clearable
                    :class="`${arabic ? 'arFont' : 'enFont'}`"
                  ></v-text-field>
                </v-col>

                <v-col
                  cols="12"
                  md="4"
                  :class="`${arabic ? 'arFont' : 'enFont'} pa-1`"
                >
                  <v-autocomplete
                    label="Sources"
                    multiple
                    dense
                    outlined
                    chips
                    small-chips
                    deletable-chips
                    v-model="sources"
                    :items="resource.sources"
                  />
                </v-col>

                <v-col
                  cols="12"
                  md="4"
                  :class="`${arabic ? 'arFont' : 'enFont'} pa-1`"
                >
                  <v-btn
                    @click="filterLeads()"
                    color="primary"
                    variant="outlined"
                    :loading="loading"
                  >
                    {{ i18n.filter }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" Paging>
          <Paging
            :resourceSettings="resourceSettings"
            :resource="resource.meta"
            @loadResource="loadResource"
            @pageByNumber="pageByNumber"
          />
        </v-col>
        <v-col cols="12" Details>
          <v-card class="px-3" :loading="loading">
            <v-card-text>
              <JobListings :data="resource.data" />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import Search from "@/components/Search";
import Paging from "@/components/Paging";
import JobListings from "@/components/JobListings";
import {
  getRandomInt,
  randomString,
  getCDate,
  check,
  sleep,
} from "@/customFunction";
import { format, render, cancel, register } from "timeago.js";
import axios from "axios";
const headers = { Accept: "application/json" };

export default {
  components: { Search, Paging, JobListings },
  data() {
    return {
      loading: false,
      dialog: false,
      newDialog: false,
      menu: false,
      menu2: false,
      campaign: {},
      vresource: [],
      contract_type: [
        {
          text: "Work",
          value: "Work",
        },
        {
          text: "Ausbildung",
          value: "Ausbildung",
        },
      ],
      resource: [],
      search: null,
      rules: {
        required: (value) => !!value || this.i18n["required"],
        email: (value) =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) ||
          this.i18n["valid_email"],
      },

      resourceSettings: {
        resourceName: null,
        search: true,
        create: false,
        pagination: true,
      },

      sources: [],
      newResource: {},
      editing: false,
      deleting: false,
      templates: [],
      programs: [],
      bundeslands: [],
      emails: [],
      sectors: [],
      usersall: [],
      lists: [],
      newCount: 0,
      state_id: [],
      city_id: [],
      occupation_id: [],
      contract_category_type: null,
      number_of_vacancies: null,
      menu1: false,
      menu2: false,
      fromDate: null,
      toDate: null,
      page: 1,
    };
  },

  methods: {
    filterObject(item, queryText, itemText) {
      let v = Object.values(item).filter((x) => typeof x == "string");
      let a = false;
      v.forEach((x) => {
        if (x.toLowerCase().includes(queryText.toLowerCase())) a = true;
      });
      if (
        itemText &&
        typeof itemText == "string" &&
        itemText.toLowerCase().includes(queryText.toLowerCase())
      )
        a = true;
      return a;
    },
    async loadItems() {
      //   return new Promise(async (res, rej) => {
      //     let ks = this.resourceKeys.filter(
      //       (x) => x.type == "select" && x.source == "db"
      //     );
      //     (async (x) => {
      //       for (let i = 0; i < ks.length; i++) {
      //         const f = ks[i];
      //         let t = this.resource[f];
      //         if (!t.error) {
      //           let maps = t.map((x) => {
      //             let t = x.name
      //               ? x.name
      //               : x.company
      //               ? x.company
      //               : x.country
      //               ? x.country
      //               : x.program
      //               ? x.program
      //               : null;
      //             console.log(t);
      //             return { ...x, text: t, [`${f.items}_id`]: x.id };
      //           });
      //           f.data = maps;
      //         }
      //       }
      //       res(true);
      //     })();
      //   });
    },
    // validate(newResource, notify) {
    //   let fsr = this.resourceKeys.filter((x) => x.required);
    //   let fse = this.resourceKeys.filter((x) => x.email);
    //   let v = true;
    //   fsr.forEach((x) => {
    //     if (!newResource[x.name]) {
    //       v = false;
    //       if (notify)
    //         this.$emit(
    //           "snackbarNotification",
    //           `${this.i18n[x.name]} ${this.i18n.required}`,
    //           "error"
    //         );
    //     }
    //   });
    //   fse.forEach((x) => {
    //     if (
    //       !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
    //         newResource[x.name]
    //       )
    //     ) {
    //       v = false;
    //       if (notify)
    //         this.$emit(
    //           "snackbarNotification",
    //           `${this.i18n[x.name]} ${this.i18n.valid_email}`,
    //           "error"
    //         );
    //     }
    //   });
    //   return v;
    // },
    getItems(items) {
      return this[items];
    },
    getExtraItems(items) {
      return this[items];
    },
    superA() {
      return (
        this.$store.state.user && this.$store.state.user.role == "superadmin"
      );
    },
    getFormat(d) {
      return format(d);
    },
    isNumber(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode != 46 &&
        charCode != 45 &&
        charCode != 46 &&
        !(charCode >= 48 && charCode <= 57)
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    goTo(path) {
      this.$router.push(path).catch((x) => {});
    },
    buildFilter() {
      let filter = ``;
      if (this.state_id) {
        filter += `&state_id=${[this.state_id].join(",")}`;
      }
      if (this.city_id) {
        filter += `&city_id=${[this.city_id].join(",")}`;
      }
      if (this.occupation_id) {
        filter += `&occupation_id=${[this.occupation_id].join(",")}`;
      }
      if (this.number_of_vacancies) {
        filter += `&number_of_vacancies=${this.number_of_vacancies}`;
      }
      if (this.contract_category_type) {
        filter += `&contract_category_type=${this.contract_category_type}`;
      }
      if (this.fromDate) {
        filter += `&fromDate=${this.fromDate}`;
      }
      if (this.toDate) {
        filter += `&toDate=${this.toDate}`;
      }
      if (this.sources.length) {
        filter += `&source=${this.sources.join(",")}`;
      }
      return filter;
    },
    async filterLeads() {
      await this.loadResource();
    },

    async loadResource() {
      return new Promise(async (res, rej) => {
        this.loading = true;
        if (!this.search) {
          this.resource = await this.$store.dispatch("getResource", {
            resource: this.$route.path,
            page: `?page=${this.page}` + this.buildFilter(),
          });

          console.log(this.resource);
        } else {
          this.resource = await this.$store.dispatch("searchResource", {
            resource: this.$route.path + "/search",
            value: this.search,
          });
        }
        this.loading = false;
        res(true);
      });
    },
    async pageByNumber(n) {
      return new Promise(async (res, rej) => {
        this.loading = true;
        this.page = n;
        if (!this.search) {
          this.resource = await this.$store.dispatch("getResource", {
            resource: this.$route.path,
            page: `?page=${n}` + this.buildFilter(),
          });
        } else {
          this.resource = await this.$store.dispatch("searchResource", {
            resource: this.$route.path + `/search?page=${n}`,
            value: this.search,
          });
        }
        this.loading = false;
      });
    },
    async searchResource(search) {
      return new Promise(async (res, rej) => {
        this.search = search;
        this.loading = true;
        this.resource = await this.$store.dispatch("searchResource", {
          resource: this.$route.path + "/search",
          value: this.search,
        });
        this.loading = false;
      });
    },
    async updateResource(r) {
      return new Promise(async (res, rej) => {
        this.loading = true;
        await this.$store.dispatch("putResource", {
          resource: this.$route.path + `/${r.id}`,
          value: r,
        });
        this.dialog = false;
        this.editing = false;
        this.loading = false;
        await this.loadResource();
        this.newResource = {};
      });
    },
    async deleteResource(r) {
      return new Promise(async (res, rej) => {
        this.loading = true;
        await this.$store.dispatch("deleteResource", {
          resource: this.$route.path + `/${r.id}`,
        });
        this.dialog = false;
        this.deleting = false;
        this.loading = false;
        await this.loadResource();
        this.newResource = {};
      });
    },
    async postResource(r) {
      return new Promise(async (res, rej) => {
        this.loading = true;
        console.log(JSON.stringify(r));
        await this.$store.dispatch("postResource", {
          resource: this.$route.path + `${r.id ? "/" + r.id : ""}`,
          value: r,
        });
        this.dialog = false;
        this.loading = false;
        await this.loadResource();
        this.newResource = {};
      });
    },
    setResourceName() {
      this.resourceSettings.resourceName = this.$route.path.replace("/", "");
    },
  },
  watch: {},
  computed: {
    api() {
      return this.$store.state.settings.apiBase;
    },
    users() {
      let sa =
        this.$store.state.user && this.$store.state.user.role == "superadmin";
      console.log(sa);
      return this.$store.state.users.filter((x) => {
        if (!sa) {
          return x.superior == this.$store.state.user.level;
        } else return x;
      });
    },
    site() {
      return this.$store.state.site;
    },
    items() {
      return this.$store.state.menu;
    },
    superAdmin() {
      return this.$store.state.superAdmin;
    },
    isLogin() {
      return this.$store.state.centralLogin;
    },
    language() {
      return this.$store.state.language;
    },
    globalLoading() {
      return this.$store.state.globalLoading;
    },
    user() {
      return this.$store.state.user;
    },
    i18n() {
      return this.$store.state.i18n[this.$store.state.language];
    },
    arabic() {
      if (this.$store.state.language == "ar") return true;
    },
    routeTitle() {
      let main = this.$store.state.menu.filter(
        (x) => x.path == this.$route.path
      );
      let sub = []
        .concat(...this.$store.state.menu.map((x) => x.subs))
        .filter((x) => x)
        .filter((x) => x.path == this.$route.path);
      if (main.length) {
        return this.$store.state.i18n[this.$store.state.language][main[0].text];
      } else if (sub.length) {
        return this.$store.state.i18n[this.$store.state.language][sub[0].text];
      } else {
        return "";
      }
    },
    roles() {
      return this.$store.state.userRoles;
    },
    notifications() {
      return this.$store.state.notifications.sort(
        (a, b) => b.timestamp - a.timestamp
      );
    },
  },
  async created() {
    await this.loadResource();
    await this.setResourceName();
    await this.loadItems();
  },
};
</script>

<style>
.adminSwitch .v-input {
  margin-top: 0 !important;
}
.adminSwitch .v-input__control {
  margin-bottom: 0 !important;
}
.adminSwitch .v-label {
  font-size: 12px !important;
}
</style>
